/* eslint-disable complexity */
import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Button from "../button";
import loadable from "@loadable/component";
import { PRICE_DISCOVERY, PURCHASE_REQUEST_STATUS } from "../../../constants/seller-diy-constants";
import SemiModal from "../semi-modal";
import { getOwnerShipQuestion } from "./selector";
import PostInspectionDiyQuestions from "./questions";
import { sendCustomGaEvents } from "../../../tracking";
import { sellNowClicked, directOcbAcceptPrice } from "./tracking";
import { NUMBER } from "../../../constants/app-constants";
import { DIRECT_OCB_VARIANTS } from "../post-inspection-diy/constant";
import { TAB_NAMES } from "../post-inspection-diy-header-v2/constant";

const SwipeableButton = loadable(() => import("../swipeable-button"));

// eslint-disable-next-line max-statements
const PostInspectionDiyAcceptPrice = ({
    inspectionResponse,
    ctaText = "Sell now",
    sliderText = "SLIDE TO ACCEPT PRICE",
    displayNatively = false,
    onSuccess = () => { },
    createNewPurchaseRequestConnect,
    initiatePRProcessConnect,
    isModal = false,
    setActiveTabConnect = () => { },
    isMobile,
    helperVideos = []
}) => {
    const [askQuestions, setAskQuestions] = useState(false);
    const [resetSwipe, setResetSwipe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const {
        purchaseRequestStatus,
        token,
        priceDiscovery,
        isNocAvailable = false,
        appointmentId,
        directOcb,
        featureData = {}
    } = inspectionResponse || {};
    const { dnpPriceConfirmationEnabled = false} = featureData || {};
    const isPrExists = purchaseRequestStatus === PURCHASE_REQUEST_STATUS.CREATED;
    const questionList = useMemo(() => getOwnerShipQuestion(), []);

    useEffect(() => {
        if (priceDiscovery === PRICE_DISCOVERY.ACCEPTED && !isPrExists) setAskQuestions(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUserJourney = () => {
        setIsLoading(false);
        setActiveTabConnect(TAB_NAMES.DOCUMENTATION);
        onSuccess();
    };

    const onConfirmation = (payload) => {
        setIsLoading(true);
        createNewPurchaseRequestConnect(token, payload).then(() => {
            handleUserJourney();
        }).catch(() => {
            setIsLoading(false);
        });
    };

    const handlePriceAcceptance = () => {
        sendCustomGaEvents({
            ...sellNowClicked,
            eventLabel: appointmentId
        });
        if (DIRECT_OCB_VARIANTS.includes(directOcb)) {
            sendCustomGaEvents({
                ...directOcbAcceptPrice,
                eventLabel: appointmentId
            });
        }
        const payload = {
            isNocAvailable,
            ...(dnpPriceConfirmationEnabled && {dnpAccepted: true})
        };
        if (!isMobile) setIsLoading(true);
        initiatePRProcessConnect(token, payload).then(() => {
            if (isMobile)setIsSuccess(true);
            window.setTimeout(() => {
                setIsSuccess(false);
                if (isPrExists) handleUserJourney();
                else {
                    setIsLoading(false);
                    setAskQuestions(true);
                }
            }, NUMBER.TWO_THOUSAND);
        }).catch(() => setResetSwipe(true));
    };

    const closeHandler = () => {
        setAskQuestions(false);
    };

    const renderQuestions = () => {
        return (
            <PostInspectionDiyQuestions
                isLoading={isLoading}
                questionList={questionList}
                onConfirmation={onConfirmation}
                closeHandler={closeHandler}
                allowClosePopup={false} //for v1
                helperVideos={helperVideos}
            />
        );
    };

    const renderQuestionLayout = () => {
        if (displayNatively) return renderQuestions();
        return (
            <SemiModal>
                {renderQuestions()}
            </SemiModal>
        );
    };

    if (askQuestions) return renderQuestionLayout();

    return (
        <div styleName={isModal ? "styles.sellNowPopup" : "styles.sellNowCta"}>
            {isMobile ?
                <SwipeableButton
                    onSuccess={handlePriceAcceptance}
                    isSuccess={isSuccess}
                    text={sliderText}
                    setResetSwipe={setResetSwipe}
                    resetSwipe={resetSwipe}
                /> :
                <Button
                    text={ctaText}
                    isLoading={isLoading}
                    onClick={handlePriceAcceptance}
                />
            }
        </div>
    );
};

PostInspectionDiyAcceptPrice.propTypes = {
    inspectionResponse: PropTypes.object,
    ctaText: PropTypes.string,
    displayNatively: PropTypes.bool,
    onSuccess: PropTypes.func,
    createNewPurchaseRequestConnect: PropTypes.func,
    initiatePRProcessConnect: PropTypes.func,
    isModal: PropTypes.bool,
    sliderText: PropTypes.string,
    showSlider: PropTypes.bool,
    setActiveTabConnect: PropTypes.func,
    isMobile: PropTypes.bool,
    helperVideos: PropTypes.array
};

export default PostInspectionDiyAcceptPrice;
